// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8j-n8","colMin":"styles_colMin__2pVv_"};